import Tooltip from '@mui/material/Tooltip';
import { default as React, useEffect, useRef, useState } from 'react';

interface Props {
  children: any;
  className: any;
  text: string;
}

const PopTooltip = ({ children, className, text }: Props) => {
  const textElementRef = useRef<HTMLInputElement | null>(null);

  const [hoverStatus, setHover] = useState(false);

  const compareSize = () => {
    if (textElementRef && textElementRef.current) {
      const compare = textElementRef.current.scrollHeight > textElementRef.current.clientHeight;
      setHover(compare);
    }
  };

  useEffect(() => {
    compareSize();
    window.addEventListener('resize', compareSize);
  }, []);

  useEffect(
    () => () => {
      window.removeEventListener('resize', compareSize);
    },
    []
  );

  return (
    <Tooltip
      title={text}
      disableHoverListener={!hoverStatus}
      PopperProps={{ 'data-testid': 'attribute-tooltip' } as any}
    >
      <div className={className} ref={textElementRef}>
        {children}
      </div>
    </Tooltip>
  );
};

export default PopTooltip;
